// import React from 'react'
// import Useletter from '../Useletter';
// import Foter from '../Foter';

// function Corporate() {
 
//   return (
  
//     <div>
        
//         <div className="check" style={{display:'flex'}}>
//                 <br /><div className="Ima"style={{marginLeft:"30px", marginTop:"30px"}}>
//             <img style={{width:"100%",height:"auto"}}src="https://www.junaidjamshed.com/media/CorporateImages/default/corporate.jpg"  alt="" /></div>

//                 <div className="param" style={{fontFamily:"Alata,sans serif",fontSize:"14px"}}>
//                     <div className="chek"style={{marginLeft:"10px"}}>
//                     <p style={{marginTop:"50%"}}>Please fill out the form below based on the type of
//              <br />   inquiry you have <br />Thank you.</p></div>
//                 <div className="button-row" style={{display:"flex",marginLeft:"30px"}}>
//         <button  className='bt' style={{height:"59px", width:"144px",fontFamily:"Alata,sans serif",fontSize:"14px",display:"inline-block" }}type='button'><a href="page1" style={{textDecoration:"none",color:"inherit"}}> For Corporate & <br /> Gifting</a></button>
//       &nbsp;&nbsp;&nbsp; <button  className='bt' style={{height:"59px",width:"144px",fontFamily:"Alata,sans serif",fontSize:"14px"}} type='button'><a href="page2" style={{textDecoration:"none",color:"inherit"}}> Distribution Business </a></button>
//                 </div></div></div>
                
                
                 


//       <Useletter/>
//       <Foter/>
//     </div>
//   )
// }

// export default Corporate


import Useletter from '../Useletter';
import Foter from '../Foter';
import React, { useState } from "react";

function Corporate() {
   const [hovered, setHovered] = useState(null);

  const buttonStyle = (isHovered) => ({
    height: "59px",
    width: "144px",
    fontFamily: "Alata, sans-serif",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    background: isHovered ? "black" : "white",
    color: isHovered ? "white" : "black",
    cursor: "pointer",
    transition: "0.3s",
  });

  const linkStyle = {
    textDecoration: "none",
    display: "block",
    width: "100%",
    height: "100%",
    textAlign: "center",
    lineHeight: "1.4",
    color: "inherit",
  };
  return (
    <div>
      <div
        className="check"
        style={{
          display: "flex",
          flexWrap: "wrap",       // mobile pe neeche chale jaye
          gap: "20px",
          padding: "20px",
          justifyContent: "center"
        }}
      >
        {/* Image */}
        <div
          className="Ima"
          style={{ flex: "1 1 300px", maxWidth: "600px" }}
        >
          <img
            style={{ width: "100%", height: "auto", borderRadius: "6px" }}
            src="https://www.junaidjamshed.com/media/CorporateImages/default/corporate.jpg"
            alt="Corporate"
          />
        </div>

        {/* Text + Buttons */}
        <div
          className="param"
          style={{
            flex: "1 1 300px",
            fontFamily: "Alata, sans-serif",
            fontSize: "14px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",     // mobile center
            textAlign: "center",      // mobile text center
            padding: "10px"
          }}
        >
          <div className="chek">
            <p style={{ margin: "20px 0" }}>
              Please fill out the form below based on the type of
              <br /> inquiry you have <br />Thank you.
            </p>
          </div>

          {/* <div
            className="button-row"
            style={{
              display: "flex",
              flexWrap: "wrap",    // mobile pe neeche aayenge
              gap: "15px",
              justifyContent: "center"
            }}
          >
            <button
              className="bt"
              style={{
                height: "59px",
                width: "144px",
                fontFamily: "Alata, sans-serif",
                fontSize: "14px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                background: "white",
                cursor: "pointer"
              }}
              type="button"
            >
              <a
                href="page1"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "block",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  lineHeight: "1.4"
                }}
              >
                For Corporate & <br /> Gifting
              </a>
            </button>

            <button
              className="bt"
              style={{
                height: "59px",
                width: "144px",
                fontFamily: "Alata, sans-serif",
                fontSize: "14px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                background: "white",
                cursor: "pointer"
              }}
              type="button"
            >
              <a
                href="page2"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "block",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  lineHeight: "1.4"
                }}
              >
                Distribution Business
              </a>
            </button>
          </div> */}
           <div
      className="button-row"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "15px",
        justifyContent: "center",
      }}
    >
      {/* Button 1 */}
      <button
        style={buttonStyle(hovered === 1)}
        onMouseEnter={() => setHovered(1)}
        onMouseLeave={() => setHovered(null)}
      >
        <a href="page1" style={linkStyle}>
          For Corporate & <br /> Gifting
        </a>
      </button>

      {/* Button 2 */}
      <button
        style={buttonStyle(hovered === 2)}
        onMouseEnter={() => setHovered(2)}
        onMouseLeave={() => setHovered(null)}
      >
        <a href="page2" style={linkStyle}>
          Distribution Business
        </a>
      </button>
    </div>
        </div>
      </div>

      <Useletter />
      <Foter />
    </div>
  )
}

export default Corporate;
